export const iconFontAwesomeFilmVideoCompactDisc = (
	<i className="fa-solid fa-compact-disc"></i>
);
